import React from "react";
import ReactDOM from "react-dom";
import cs from "classnames";

import { SiteNotificationButton } from "@js/apps/notifications/components/site-notification-button";
import { useLiveSiteNotifications } from "@js/apps/notifications/hooks/use-live-site-notifications";

import { SiteNotificationItem } from "../site-notification";

import style from "./style.module.scss";

export const LiveSiteNotifications = () => {
  const { hideNotification, classNames, notificationsToDisplay } =
    useLiveSiteNotifications();
  const portalsElement = document.getElementById("portals");

  if (!portalsElement) return null;

  return ReactDOM.createPortal(
    <div className={style.liveSiteNotifications}>
      {notificationsToDisplay.map((siteNotification) => {
        return (
          <SiteNotificationItem
            live
            key={siteNotification.id}
            notification={siteNotification}
            closeNotificationsPopup={() =>
              hideNotification(siteNotification.id)
            }
            className={cs(
              classNames[siteNotification.id],
              style.siteNotification,
            )}
          >
            {!!siteNotification.buttons.length && (
              <div className={cs("right", style.liveSiteNotificationsButtons)}>
                {siteNotification.buttons.map((button) => (
                  <SiteNotificationButton
                    button={button}
                    key={button.id}
                    context={siteNotification.context}
                    hideNotification={hideNotification}
                  />
                ))}
              </div>
            )}
          </SiteNotificationItem>
        );
      })}
    </div>,
    portalsElement,
  );
};
